import { table6_1 } from '@/mocks/tableData';

export interface CalculationResult {
  ts: number;
  M: number;
  a: number;
  hc: number;
  pf: number;
  isExtrapolated: boolean;
  note: string;
}

function linearInterpolate(x: number, x0: number, x1: number, y0: number, y1: number): number {
  return y0 + ((y1 - y0) * (x - x0)) / (x1 - x0);
}

export function calculatePF(ts: number, hc: number): CalculationResult {
  let M: number;
  let a: number;
  let isExtrapolated = false;
  let note = '';

  if (ts < 7) {
    M = table6_1[0].M;
    a = table6_1[0].a;
    isExtrapolated = true;
    note = `Ts = ${ts}°C 低于方法学下限 7°C，使用边界值外推，结果仅供参考`;
  } else if (ts > 40) {
    M = table6_1[table6_1.length - 1].M;
    a = table6_1[table6_1.length - 1].a;
    isExtrapolated = true;
    note = `Ts = ${ts}°C 高于方法学上限 40°C，使用边界值外推，结果仅供参考`;
  } else {
    const lowerIndex = Math.floor(ts) - 7;
    const upperIndex = Math.ceil(ts) - 7;

    if (lowerIndex === upperIndex) {
      M = table6_1[lowerIndex].M;
      a = table6_1[lowerIndex].a;
    } else {
      const x0 = table6_1[lowerIndex].ts;
      const x1 = table6_1[upperIndex].ts;
      M = linearInterpolate(ts, x0, x1, table6_1[lowerIndex].M, table6_1[upperIndex].M);
      a = linearInterpolate(ts, x0, x1, table6_1[lowerIndex].a, table6_1[upperIndex].a);
    }
  }

  const pf = M - a * hc;

  return {
    ts,
    M: parseFloat(M.toFixed(2)),
    a: parseFloat(a.toFixed(2)),
    hc,
    pf: parseFloat(pf.toFixed(2)),
    isExtrapolated,
    note,
  };
}